import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';

const SvgArrowBackOutlined = ({ size, title = 'ArrowBackOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M6.464 12H18.25 6.464zM11.5 5.75L5.5 12l6-6.25zm0 12.5L5.5 12l6 6.25z"
            />
        </g>
    </svg>
);

export default withIcon(SvgArrowBackOutlined);
